/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Status_CanceledInputs */

const fr_membership_status_canceled = /** @type {(inputs: Membership_Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résilié`)
};

/**

* @param {Membership_Status_CanceledInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_status_canceled = /** @type {((inputs?: Membership_Status_CanceledInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Status_CanceledInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_status_canceled(inputs)
});